export const LOYALTY_SEGMENTS: string[] = ['direct'];
